import React, { Fragment, useEffect } from "react";
import { getFieldPath } from "utils/form";
import get from "lodash/get";
import { useFormikContext } from "formik";
import FieldListFactory from "components/FieldListFactory";
import Toggle from "react-toggle";
import { getToggleProps } from "utils/form";
import { STATE_KEYS } from "utils/constants/state";
import { useAppCheckout } from "utils/selectors";
import { LIST_PICKER_CUSTOM_CLASSES } from "utils/constants/ui";
import OptionListPicker from "components/OptionListPicker";
import { SET_TOUCH_TIMEOUT } from "utils/constants/form";
import { useIsManifestEditMode } from "utils/hooks/manifest";

const ValuesFields = ({ name }) => {
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();
  const isEditMode = useIsManifestEditMode();

  const checkout = useAppCheckout();

  const receiverEnabledPath = getFieldPath(
    name,
    STATE_KEYS.ADDRESS.RECEIVER_ENABLED
  );
  const recevierEnabledValue = get(values, receiverEnabledPath);

  const receiverRequiredPath = getFieldPath(
    name,
    STATE_KEYS.ADDRESS.RECEIVER_REQUIRED
  );
  const recevierRequiredValue = get(values, receiverRequiredPath);

  useEffect(() => {
    if (!recevierEnabledValue && recevierRequiredValue) {
      setFieldValue(receiverRequiredPath, false);
      if (!get(touched, receiverRequiredPath)) {
        setTimeout(() => {
          setFieldTouched(receiverRequiredPath, true);
        }, SET_TOUCH_TIMEOUT);
      }
    }
  }, [recevierEnabledValue]);

  const addressTypeOptions =
    get(checkout, STATE_KEYS.APP_CHECKOUT.ADDRESS_TYPES) || [];
  const addressTypePath = getFieldPath(name, STATE_KEYS.ADDRESS.TYPE);
  const addressTypeValue = get(values, addressTypePath);

  const addressTypeProps = {
    label: "Address type",
    value: addressTypeValue,
    name: addressTypePath,
    multiselect: false,
    disabled: isEditMode,
    options: addressTypeOptions,
    onClick: (_, selectedValue) => {
      setFieldValue(addressTypePath, selectedValue);
      if (!get(touched, addressTypePath)) {
        setFieldTouched(name, true);
      }
    },
    canUnset: false,
    customClasses: LIST_PICKER_CUSTOM_CLASSES
  };

  return (
    <Fragment>
      <FieldListFactory
        name={name}
        config={[
          {
            name: "label"
          },
          {
            name: "placeholder",
            placeholder: "Address line 1"
          },
          {
            name: "description"
          }
        ]}
      />
      <div className="w-100 pt3">
        <div className="f5 pb2 fw6">Type</div>
        <div className="f6 lh-copy">
          Set which type of address component to use.
        </div>
        <div className="pt3">
          <OptionListPicker {...addressTypeProps} />
        </div>
      </div>
      <div className="pt4 mt4 bt hairline-1">
        <div className="f5 pb2 fw6">Receiver</div>
        <div className="f6 lh-copy">Optional receiver information capture.</div>
        <div className="pt3 w-100">
          <div className="flex flex-row w-100 justify-between items-center pb2">
            <div className="f6 dib fw6">Enabled</div>
            <Toggle
              {...getToggleProps({
                active: recevierEnabledValue,
                disabled: isEditMode,
                setFieldValue: (_, active) => {
                  setFieldValue(receiverEnabledPath, active);
                  setTimeout(() => {
                    setFieldTouched(receiverEnabledPath, true);
                  }, SET_TOUCH_TIMEOUT);
                }
              })}
            />
          </div>
          <div className="f6 lh-copy">
            Show an input to capture a receiver's name.
          </div>
        </div>
        <div className="pt3 mt2">
          <div className="flex flex-row w-100 justify-between items-center pb2">
            <div className="f6 dib fw6">Required</div>
            <Toggle
              {...getToggleProps({
                active: recevierRequiredValue,
                disabled: !recevierEnabledValue || isEditMode,
                setFieldValue: (_, active) => {
                  setFieldValue(receiverRequiredPath, active);
                  setTimeout(() => {
                    setFieldTouched(receiverRequiredPath, true);
                  }, SET_TOUCH_TIMEOUT);
                }
              })}
            />
          </div>
          <div className="f6 lh-copy">
            Require that the receiver's name be filled out.
          </div>
        </div>
        <div className="pt3 mt2">
          <FieldListFactory
            name={name}
            config={[
              {
                name: STATE_KEYS.ADDRESS.RECEIVER_PLACEHOLDER,
                label: "Placeholder",
                disabled: !recevierEnabledValue
              }
            ]}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default ValuesFields;
